"use client";
import { useEffect } from "react";
import { useGetContract } from "@/hooks/useGetContract";
import { Process } from "@/types/contract";

const SCRIPT_ID = "born_digital.bubble-script";

const getConfig = () => {
  const env = process.env.NEXT_PUBLIC_ENVIRONMENT;

  if (env === "TEST") {
    return {
      src: "https://customer-test.borndigital.ai/da-bubble/bubble.js",
      clientId: "6a390aa2a564a22d9ef6280c",
    };
  }
  if (env === "PROD" || env === "PREPROD") {
    return {
      src: "https://customer-prod.borndigital.ai/da-bubble/bubble.js",
      clientId: "6a4f7405f3619adcb2c7c076",
    };
  }
  return null;
};

const injectScript = (cfg: { src: string; clientId: string }) => {
  const script = document.createElement("script");
  script.src = cfg.src;
  script.type = "module";
  script.id = SCRIPT_ID;
  script.dataset.clientId = cfg.clientId;
  script.async = true;
  document.body.appendChild(script);
};

type ElaScriptProps = {
  contractId?: string;
  process?: Process;
};

export default function ElaScript({ contractId, process: processProp }: ElaScriptProps) {
  const { data } = useGetContract(contractId ?? "");
  const resolvedProcess = processProp ?? data?.contract.process;
  const isPS = resolvedProcess === Process.PS;

  useEffect(() => {
    if (process.env.NEXT_PUBLIC_ELA_FEATURE_FLAG !== "true" || !isPS) {
      return;
    }
    if (document.getElementById(SCRIPT_ID)) {
      return;
    }

    const cfg = getConfig();
    if (!cfg) {
      return;
    }

    injectScript(cfg);

    return () => {
      document.getElementById(SCRIPT_ID)?.remove();
    };
  }, [isPS]);
  return null;
}
